export default "__VITE_ASSET__102279f3__"